import { pingResponseSchema } from "@pushup/shared";
import type { PingResponse } from "@pushup/types";
import { api } from "@/lib/api";

export async function sendPing(message: string): Promise<PingResponse> {
  const data = await api.post<unknown>("/ping", { message });
  return pingResponseSchema.parse(data);
}
